import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React, { ReactNode } from 'react';
import { Button, Divider, Grid, SectionHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ApplicationStatus from '../summary/ApplicationStatus';
import PersonalDetails from '../summary/PersonalDetails';
import TransactionDetails from '../summary/TransactionDetails';
import FeeDetails from '../summary/FeeDetails';
import SelectedSubjectsReview from '../summary/SelectedSubjectsReview';
import { AppealSummaryResponse } from '../../../../api/candidate/appeal/model';

interface AppealSummaryProps {
  appealSummary?: AppealSummaryResponse;
  additionalComponent?: ReactNode;
  backButton: {
    label: string;
    name: string;
  };
}

const useStyles = makeStyles()((theme) =>
({
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
}));

const ResultsAppealSummary = ({
  appealSummary,
  additionalComponent,
  backButton,
}: AppealSummaryProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      {appealSummary ? (
        <>
          <Grid container>
            <Grid xs={12}>
              <SectionHeader
                title={t('appeal->>AppealSummary.ApplicationDetails')}
                >
                {additionalComponent}
              </SectionHeader>
            </Grid>
            <Grid xs={12}>
              <ApplicationStatus {...appealSummary.applicationStatus} />
            </Grid>
          </Grid>

          <Divider />

          <Grid container>
            <Grid xs={12}>
              <PersonalDetails {...appealSummary.candidateDetails} />
            </Grid>
          </Grid>

          <Divider />

          <Grid container>
            <Grid xs={12}>
              <SelectedSubjectsReview {...appealSummary.selectedSubjects} />
            </Grid>
          </Grid>

          <Divider />

          <Grid container>
            <Grid xs={12}>
              <FeeDetails {...appealSummary.appealFees} />
            </Grid>
          </Grid>

          <Divider />

          <Grid container>
            <Grid xs={12}>
              <TransactionDetails {...appealSummary.transactionDetails} />
            </Grid>
          </Grid>

          <Grid container>
            <Grid xs={4}>
              <Button
                id={`button-appealSummary-${backButton.name}`}
                className={classes.button}
                onClick={() => history.goBack()}
                variant="outlined"
              >
                {backButton.label}
              </Button>
            </Grid>
          </Grid>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
export default ResultsAppealSummary;
